/**
 * Returns the React Query key used to cache the MagicBell token for a specific user.
 */
export function getMagicBellTokenQueryKey(userId: string | null) {
    return ['magicbell-token', userId] as const;
}

/**
 * Returns the React Query key used to cache notification pages for a specific user.
 */
export function getMagicBellNotificationsQueryKey(userId: string | null) {
    return ['magicbell', 'notifications', userId] as const;
}

/**
 * Returns the React Query key used to cache the unread notification count for a specific user.
 */
export function getMagicBellUnreadCountQueryKey(userId: string | null) {
    return ['magicbell', 'unread-count', userId] as const;
}
